export default __webpack_public_path__ + "static/media/event_2.b7bee407.png";